import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { AppAuthStatusEnum, type AppAuthState } from "../Redux/AppAuthReducer";
import { useBootstrapAuth } from "./useBootstrapAuth";
import type { PicoAppEnum } from "jadro-pico/apps/PicoAppEnum";
import type { PicoRoleEnum } from "jadro-pico/enums/auth/PicoRoleEnum";

interface RequireAuthProps {
  picoComApiUrl: string;
  loginUrl: string;
  requiredRole?: { client: PicoAppEnum; role: PicoRoleEnum };
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

const RequireAuth: React.FC<RequireAuthProps> = ({
  picoComApiUrl,
  loginUrl,
  requiredRole,
  fallback = null,
  children,
}) => {
  useBootstrapAuth(`${picoComApiUrl}/auth/user`);
  const { user, status } = useSelector((s: { auth: AppAuthState }) => s.auth);

  useEffect(() => {
    if (status === AppAuthStatusEnum.UNAUTHENTICATED) {
      const returnTo = encodeURIComponent(window.location.href);
      window.location.href = `${loginUrl}?returnTo=${returnTo}`;
    }
  }, [status, loginUrl]);

  if (status !== AppAuthStatusEnum.AUTHENTICATED || !user) return <>{fallback}</>;

  if (requiredRole) {
    const roles = user.resource_access?.[requiredRole.client]?.roles ?? [];
    if (!roles.includes(requiredRole.role)) {
      return <>{fallback ?? <div>Forbidden</div>}</>;
    }
  }

  return <>{children}</>;
};

export default RequireAuth;
